import { render, staticRenderFns } from "./MyCRMDashboard.vue?vue&type=template&id=60156d64&scoped=true&"
import script from "./MyCRMDashboard.vue?vue&type=script&lang=js&"
export * from "./MyCRMDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60156d64",
  null
  
)

export default component.exports